function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "Icon/Settings/Gray/Alt");

var _ref3 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "Icon/Settings/Gray/Alt",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd",
  strokeLinecap: "square"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group",
  transform: "translate(1.000000, 1.000000)",
  stroke: "#909193",
  strokeWidth: 1.25
}, /*#__PURE__*/React.createElement("circle", {
  id: "Oval",
  cx: 17,
  cy: 17,
  r: 5.40909091
}), /*#__PURE__*/React.createElement("path", {
  d: "M34,19.3181818 L34,14.6818182 L29.0545455,14.2691818 C28.7449689,12.9016333 28.2034424,11.597213 27.4534545,10.4125 L30.6641364,6.61840909 L27.3815909,3.33972727 L23.5875,6.55040909 C22.4031463,5.79887623 21.0986787,5.25602322 19.7308182,4.94545455 L19.3181818,0 L14.6818182,0 L14.2691818,4.94545455 C12.9016333,5.25503114 11.597213,5.79655765 10.4125,6.54654545 L6.61840909,3.33586364 L3.33972727,6.61840909 L6.55040909,10.4125 C5.79887623,11.5968537 5.25602322,12.9013213 4.94545455,14.2691818 L0,14.6818182 L0,19.3181818 L4.94545455,19.7308182 C5.25503114,21.0983667 5.79655765,22.402787 6.54654545,23.5875 L3.33586364,27.3815909 L6.61454545,30.6602727 L10.4086364,27.4495909 C11.5941725,28.2015291 12.8999798,28.7443958 14.2691818,29.0545455 L14.6818182,34 L19.3181818,34 L19.7308182,29.0506818 C21.0983667,28.7411052 22.402787,28.1995787 23.5875,27.4495909 L27.3815909,30.6602727 L30.6602727,27.3815909 L27.4495909,23.5875 C28.2011238,22.4031463 28.7439768,21.0986787 29.0545455,19.7308182 L34,19.3181818 Z",
  id: "Path"
})));

var SvgSettingsIcon = function SvgSettingsIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "36px",
    height: "36px",
    viewBox: "0 0 36 36",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSettingsIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/settings-icon.eed93e29.svg";
export { ForwardRef as ReactComponent };